export const PermissionGroupTR={
PerGID:{en:'PerGID',cs:'PerGID',dataType:'number',format:'#0',required:true},
PerGName:{en:'Permission Group Name',cs:'',dataType:'string',required:true,maxLength:255},
PerGDescription:{en:'Description',cs:'',dataType:'string',maxLength:500},
PerGIsActive:{en:'Active',cs:'',dataType:'boolean',required:true},
PerGTimeStamp:{en:'PerGTimeStamp',cs:'PerGTimeStamp',dataType:'number',format:'#0'}
}